var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 170,
    viewBox: "0 0 261 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 261,
    height: 170,
    rx: 15,
    fill: "#F1F5F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.194 112.995C121.818 112.995 112.443 112.995 103.068 112.995C102.61 112.995 102.146 112.995 101.686 112.947C99.3389 112.725 98.3953 111.127 99.3961 108.966C100.265 107.101 101.212 105.283 102.132 103.438C106.475 94.7475 110.818 86.0588 115.161 77.3715C115.295 77.1061 115.435 76.8407 115.591 76.5873C116.685 74.8155 118.461 74.5661 119.861 76.0945C120.848 77.164 121.683 78.3651 122.563 79.5244C127.038 85.4343 131.512 91.3469 135.987 97.2622C137.941 99.8361 140.402 99.9758 142.698 97.6613C143.837 96.512 144.951 95.3328 146.103 94.1935C148.182 92.1384 150.541 92.2621 152.239 94.6584C155.646 99.467 158.968 104.339 162.306 109.196C162.567 109.577 162.767 109.997 162.898 110.441C163.222 111.556 162.764 112.454 161.645 112.751C160.943 112.921 160.223 113 159.501 112.985C150.071 113.001 140.635 113.004 131.194 112.995Z",
    fill: "#D1E1F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.219 65.378C152.216 67.2328 151.669 69.0451 150.647 70.5852C149.624 72.1253 148.172 73.3238 146.474 74.0287C144.777 74.7337 142.911 74.9133 141.112 74.5449C139.314 74.1765 137.664 73.2766 136.372 71.9593C135.08 70.642 134.204 68.9666 133.856 67.1456C133.507 65.3246 133.701 63.4399 134.413 61.7305C135.126 60.0211 136.324 58.5639 137.857 57.5438C139.389 56.5236 141.187 55.9864 143.022 56.0003C145.465 56.0316 147.799 57.0323 149.519 58.7865C151.24 60.5407 152.209 62.908 152.219 65.378Z",
    fill: "#D1E1F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/Default.7e4acdf992f44468b4d5abaf3097de32.svg";
export { ForwardRef as ReactComponent };